import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { SquareButton, DialogBox } from '../../../../Styles';
import { TrashIcon } from '../../../../Styles';

import { deleteInventory } from '../../../../../actions/inventoryActionsV2';

const DeleteItem = ({ itemId, refresh = null, ...props }) => {
	const { disableSingleInventoryDelete } = props;
	const [openDeleteItem, setOpenDeleteItem] = useState(false);

	const deleteInventory = async () => {
		await props.deleteInventory(itemId);

		setOpenDeleteItem(false);
		if (refresh) {
			refresh();
		}
	};

	return (
		<>
			{!disableSingleInventoryDelete && (
				<SquareButton
					outline
					title={'Delete Item'}
					error
					onClick={(e) => {
						setOpenDeleteItem(true);
					}}
				>
					<TrashIcon />
				</SquareButton>
			)}

			<DialogBox
				open={openDeleteItem}
				title={'Delete Item'}
				content={'Are you sure you want to delete this item?'}
				onTrue={() => {
					deleteInventory();
				}}
				onFalse={() => {
					setOpenDeleteItem(false);
				}}
			/>
		</>
	);
};

const mapStateToProps = (state) => {
	const supplierSellerPortalConfig = state.supplier.sellerPortalConfig || {};
	const userSellerPortalConfig = state.session.sellerPortalConfig || {};

	const disableSingleInventoryDelete = supplierSellerPortalConfig.disable_single_inventory_delete || userSellerPortalConfig.disable_single_inventory_delete || false;

	return {
		disableSingleInventoryDelete,
	};
};

const mapDispatch = { deleteInventory };

export default withRouter(connect(mapStateToProps, mapDispatch)(DeleteItem));
